import getBaseInfoDetail from './getBaseInfoDetail';
import getDictList from './getDictList';
import getDictCategory from './getDictCategory';
import getDicts from './getDicts';
import addDictData from './addDictData';
import editDictData from './editDictData';
import deleteDictData from './deleteDictData';
import addOrEditBaseInfo from './addOrEditBaseInfo';
import getMoralDetail from './getMoralDetail';
import addOrEditMoral from './addOrEditMoral';
import getQualificationEducationDetail from './getQualificationEducationDetail';
import addOrEditQualificationEducation from './addOrEditQualificationEducation';
import getQualificationWorkDetail from './getQualificationWorkDetail';
import addOrEditQualificationWork from './addOrEditQualificationWork';
import getQualificationWorkExperienceDetail from './getQualificationWorkExperienceDetail';
import addOrEditQualificationWorkExperience from './addOrEditQualificationWorkExperience';
import getQualificationManageExperienceDetail from './getQualificationManageExperienceDetail';
import addOrEditQualificationManageExperience from './addOrEditQualificationManageExperience';
import getResearchAchievementList from './getResearchAchievementList';
import getResearchAchievementDetail from './getResearchAchievementDetail';
import addResearchAchievement from './addResearchAchievement';
import editResearchAchievement from './editResearchAchievementDetail';
import delResearchAchievement from './delResearchAchievement';
import getTeachAchievementList from './getTeachAchievementList';
import getTeachAchievementDetail from './getTeachAchievementDetail';
import addTeachAchievement from './addTeachAchievement';
import editTeachAchievement from './editTeachAchievementDetail';
import delTeachAchievement from './delTeachAchievement';
import addEducateAchievement from './addEducateAchievement';
import addOrEditEducateBaseInfo from './addOrEditEducateBaseInfo';
import delEducateAchievement from './delEducateAchievement';
import editEducateAchievement from './editEducateAchievement';
import getEducateAchievementDetail from './getEducateAchievementDetail';
import getEducateAchievementList from './getEducateAchievementList';
import getEducateBaseInfoDetail from './getEducateBaseInfoDetail';
import getTeacherBaseinfoList from './getTeacherBaseinfoList';
import getTeacherBaseInfoDetail from './getTeacherBaseInfoDetail';
import getTeacherTeachDetail from './getTeacherTeachDetail';
import getTeacherEducateDetail from './getTeacherEducateDetail';
import getTeacherResearchDetail from './getTeacherResearchDetail';
import addAwardAchievement from './addAwardAchievement';
import delAwardAchievement from './delAwardAchievement';
import editAwardAchievement from './editAwardAchievement';
import getAwardAchievementDetail from './getAwardAchievementDetail';
import getAwardAchievementList from './getAwardAchievementList';
import getTeacherPDF from './getTeacherPDF';
import getTeacherAwardList from './getTeacherAwardList';
import outputAwardExcel from './outputAwardExcel';
import getTeacherAwardDetail from './getTeacherAwardDetail';
import resetPassword from './resetPassword';
export default {
  getBaseInfoDetail,
  getDictList,
  getDictCategory,
  getDicts,
  addDictData,
  editDictData,
  deleteDictData,
  addOrEditBaseInfo,
  getMoralDetail,
  addOrEditMoral,
  getQualificationEducationDetail,
  addOrEditQualificationEducation,
  getQualificationWorkDetail,
  addOrEditQualificationWork,
  getQualificationWorkExperienceDetail,
  addOrEditQualificationWorkExperience,
  getQualificationManageExperienceDetail,
  addOrEditQualificationManageExperience,
  getResearchAchievementList,
  getResearchAchievementDetail,
  addResearchAchievement,
  editResearchAchievement,
  delResearchAchievement,
  getTeachAchievementList,
  getTeachAchievementDetail,
  addTeachAchievement,
  editTeachAchievement,
  delTeachAchievement,
  addEducateAchievement,
  addOrEditEducateBaseInfo,
  editEducateAchievement,
  delEducateAchievement,
  getEducateAchievementDetail,
  getEducateAchievementList,
  getEducateBaseInfoDetail,
  getTeacherBaseinfoList,
  getTeacherBaseInfoDetail,
  getTeacherTeachDetail,
  getTeacherEducateDetail,
  getTeacherResearchDetail,
  addAwardAchievement,
  delAwardAchievement,
  editAwardAchievement,
  getAwardAchievementDetail,
  getAwardAchievementList,
  getTeacherPDF,
  getTeacherAwardList,
  outputAwardExcel,
  getTeacherAwardDetail,
  resetPassword,
};


// WEBPACK FOOTER //
// ./src/api/progress/index.ts